














import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import Vue from 'vue';
import { format } from 'date-fns';

export default Vue.extend({
  props: {
    direction: {
      type: Number,
      required: true,
    },
    notification: {
      type: Object,
      required: true,
    },
    showNotificationDetailsFunc: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      received: Enums.eNotificationDirection.received,
    };
  },
  computed: {
    formattedNotificationMessage() {
      const notification: AnyNotification = this.$props.notification;
      if (!notification) {
        return;
      }
      if (this.$props.direction === Enums.eNotificationDirection.received) {
        if (this.notification.type === Enums.eNotificationTypes.question && notification.status === Enums.eNotificationStatuses.accepted) {
          return {
            tag: Util.t?.questionAnswered,
            message: notification.response || Util.t?.pressForDetails,
          };
        } else {
          return {
            tag: Util.toTitleCase(Util.t[notification.type]) + ' ' + Util.t[notification.status],
            message: notification.response || Util.t?.pressForDetails,
          };
        }
      }
      if (this.$props.direction === Enums.eNotificationDirection.sent) {
        const tag = Util.toTitleCase(Util.t[notification.type]);
        switch (this.notification.type) {
          case Enums.eNotificationTypes.cancellationRequest:
          case Enums.eNotificationTypes.payment:
          case Enums.eNotificationTypes.tablesideOrder:
          case Enums.eNotificationTypes.takeoutOrder:
          case Enums.eNotificationTypes.deliveryOrder:
          case Enums.eNotificationTypes.bill:
            return {
              tag,
              message: Util.t?.pressForDetails,
            };
            break;
          case Enums.eNotificationTypes.request:
          case Enums.eNotificationTypes.question:
          case Enums.eNotificationTypes.feedback:
            return {
              tag,
              message: (notification as MessageNotification).message,
            };
            break;
        }
      }
    },
  },
  methods: {
    formatDate(dateInMs: number): string {
      return format(new Date(dateInMs), 'h:mma');
    },
    onShowDetails() {
      this.$props.showNotificationDetailsFunc({
        ...this.$props.notification,
        direction: this.$props.direction,
      });
    },
  },
});
